import { Box, Stack } from '@mui/material';
import {
  MyTimesheetWidget,
  OnCallTile,
  TimesheetsPendingTile,
} from '../../dashboard-widgets';
import type { MyWeekWidget } from '../../dashboard-widgets/types';
import type { NavigateToTimesheetsOptions } from '../../dashboard-widgets/navigation';

interface MyTimeSectionProps {
  myWeek: MyWeekWidget | undefined;
  loading?: boolean;
  onNavigateToTimesheets?: (options?: NavigateToTimesheetsOptions) => void;
}

/**
 * `My time` section — prototype port. 2-up grid (1.6fr / 1fr split):
 *   - LEFT  : `MyWeekStrip` 7-day grid (hidden on xs/sm → compact summary)
 *   - RIGHT : stacked `TimesheetsPendingTile` + `OnCallTile`
 *
 * Mobile (xs/sm): the strip's internal fallback collapses to a single
 * row of totals, and the right-column tiles flow underneath in a single
 * column.
 */
export function MyTimeSection({
  myWeek,
  loading,
  onNavigateToTimesheets,
}: MyTimeSectionProps) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: 'minmax(0, 1.6fr) minmax(0, 1fr)' },
        gap: 2,
        alignItems: 'start',
      }}
    >
      <MyTimesheetWidget
        data={myWeek}
        loading={loading}
        onNavigateToTimesheets={onNavigateToTimesheets}
      />
      <Stack spacing={2}>
        <TimesheetsPendingTile
          count={myWeek?.pendingSubmissionCount}
          cadence={myWeek?.cadence}
          weeks={myWeek?.weeks}
          priorMonthToSubmitLabel={myWeek?.priorMonthToSubmitLabel}
          loading={loading}
          onOpenTimesheets={
            onNavigateToTimesheets
              ? () => onNavigateToTimesheets({ tab: 'my-timesheet' })
              : undefined
          }
        />
        <OnCallTile
          hours={myWeek?.onCallHoursThisWeek}
          topProjectName={myWeek?.onCallTopProjectName}
          loading={loading}
        />
      </Stack>
    </Box>
  );
}
